import { Container, Row, Col } from "react-bootstrap";
import Scrollbars from "react-custom-scrollbars";
import React, { useEffect, useState } from "react";

import { connect } from "react-redux";
import {
  fetchNewTyreItems,
  fetchNewTyreItemsHeight,
  fetchNewTyreItemsRim,
  fetchTyreSelectionItems,
  setLayer,
  setNewCarTyreSize,
} from "../../../redux/actions/globalAction";
import {
  setCartJourney,
  setCartTypeParameter,
  setShowMobileIstand,
} from "../../../redux/actions/cartAction";
import { isMobile } from "react-device-detect";
import { workshopPurchase } from "lib/config";
import { useRouter } from "next/router";
import { getNewTyresVariants } from "redux/actions/apiActions";
import toast from "react-hot-toast";

const Tyre = ({
  apiData,
  getModel,
  globalData,
  getCarBrandModal,
  cart,
  setNewCarTyreSize,
  fetchTyreSelectionItems,
  fetchNewTyreItems,
  setCartTypeParameter,
  setShowMobileIstand,
  setLayer,
  getNewTyresVariants,
  setCartJourney,
  fetchNewTyreItemsHeight,
  fetchNewTyreItemsRim
}) => {
  const [filter, setFilter] = useState(0);
  const [type, setType] = useState(0);
  const router = useRouter();
  useEffect(() => {
    // setType(typeTwo)
    //  fetchNewTyreItems();
    if (router.query.slug && router.query.slug[1] == "tyre" && !localStorage.getItem("isQuoterequest")) {
      fetchNewTyreItems()
    } else {
      fetchTyreSelectionItems()
    }

    return () => {
      if (localStorage.getItem("isCartBack")) {
        setCartTypeParameter({
          width: null,
          height: null,
          rim: null,
          isProceed: false,
          data: null,
        });
      }
    };
  }, []);

  const resetSize = () => {
    fetchNewTyreItems()
    setFilter(0)
    setCartTypeParameter({
      width: null,
      height: null,
      rim: null,
      isProceed: false,
      data: null,
    });
  }

  const setWidth = (data) => {
    let item = cart.tyreQuotation;
    item.width = data;
    setCartTypeParameter(item);
    if (router?.query?.slug && router?.query?.slug[1] == "tyre" && !localStorage.getItem("isQuoterequest")) {
      fetchNewTyreItemsHeight(item.width)
    }
    setTimeout(function () {
      setFilter(1);
    }, 500);
  };

  const setHeight = (data) => {
    let item = cart.tyreQuotation;
    item.height = data;
    setCartTypeParameter(item);
    if (router.query.slug && router.query.slug[1] == "tyre" && !localStorage.getItem("isQuoterequest")) {
      fetchNewTyreItemsRim(item.width, item.height)
    }

    setTimeout(function () {
      setFilter(2);
    }, 500);
  };

  const setRim = (data) => {
    let item = cart.tyreQuotation;
    item.rim = data;
    setCartTypeParameter(item);
  };

  const proceed = () => {
    if (cart.tyreQuotation.width === null ||
      cart.tyreQuotation.height === null ||
      cart.tyreQuotation.rim === null) {
      toast.dismiss();
      toast.error("Please Select Width, Height and Rim Sizes to Proceed.");
      return
    }
    if (router?.pathname == "/services/[...slug]" && router?.query?.slug[1] == "tyre" && !localStorage.getItem("isQuoterequest")) {
      getNewTyresVariants(cart?.tyreQuotation?.width, cart?.tyreQuotation?.height, cart?.tyreQuotation?.rim)
      setCartJourney(workshopPurchase)
      const tyreSize = {
        width: cart?.tyreQuotation?.width,
        height: cart?.tyreQuotation?.height,
        rim: cart?.tyreQuotation?.rim
      }
      setNewCarTyreSize(tyreSize)
      localStorage.removeItem("isQuoterequest");
      // localStorage.setItem("tyre_size")
      localStorage.removeItem("isCartBack");
      let item = cart.tyreQuotation;
      item.isProceed = true;
      setCartTypeParameter(item);
      if (isMobile) {
        setShowMobileIstand(false);
      }
      setLayer(false)

    } else {
      localStorage.removeItem("isCartBack");
      let item = cart.tyreQuotation;
      item.isProceed = true;
      setCartTypeParameter(item);

    }
  };

  const handleOBSelect = () => {
    setWidth(0);
    setHeight(0);
    setRim(0);
    proceed();
  };
  let widths = globalData.tyreItems.filter((item) => item.Width !== "")
  let heights = globalData.tyreItems.filter((item) => item.Height !== "")
  let rims = globalData.tyreItems.filter((item) => item.Rim !== "")



  return (
    <div
      className="sr-service-dv1"
      style={{ paddingTop: "19px", overflow: "hidden" }}
    >
      <Scrollbars
        className="quote-request-box"
        style={{
          height: isMobile ? "calc(100vh - 208px)" : "calc(100vh - 140px)",
          marginBottom: "10px",
          width: "100%",
        }}
      >
        <Container fluid>
          <Row>
            <Col className="tyre mt-3">
              <div className="d-flex  justify-content-between align-items-center">
                <h4>
                  Service Selected:{" "}
                  <span className="text-custom-blue">New Tyre</span>
                </h4>
                {/* {
                  router?.pathname=== `/services/[...slug]` && router?.query?.slug[1]=="tyre" && !localStorage.getItem("isQuoterequest") &&
   <div
   className={
    cart?.tyreQuotation?.width
       ? "tyre-rest-btn"
       : "tyre-rest-btn d-none"
   }
   onClick={() => resetSize()}
 >
   <span>Reset</span>
 </div>
                } */}
                {/* {isMobile ? ( */}
                <img
                  onClick={() => {
                    //setShowQuoteSelect(false)
                    setShowMobileIstand(false);
                    setLayer(false);
                    localStorage.removeItem("isQuoterequest");
                    setCartJourney(workshopPurchase);
                  }}
                  src="/assets/BACK.png"
                  width="25px"
                  height={25}
                  style={{ marginRight: "10px" }}
                ></img>
                {/* ) : null} */}
              </div>
              <p className="text-black description">
                Please share any details or requirements that can help us to
                look out for the best Tires Quotes for your car.
              </p>
              {/* <div style={{display:'flex',flexDirection:'row',padding:'10px',alignItems:'center'}}>
                <div style={{fontSize:'20px',fontWeight:'600'}}>Service Selected:</div>
                <div style={{fontSize:'25px',fontWeight:'600',color:'#0451be',marginLeft:'7px'}}> { type==0 ? "New Tyre" : "Battery"}</div>
            </div> */}
              {/* <div style={{display:'flex',flexDirection:'row',padding:'10px',alignItems:'center'}}>
                <div style={{fontSize:'15px',fontWeight:'500'}}></div>
            </div> */}
              <div className="position-relative mb-3 mt-4">
                <h4 className="mb-2">Select Tyre Size</h4>
              </div>

              {/* <div style={{display:'flex',flexDirection:'row',padding:'10px',alignItems:'center'}}>
                <div style={{fontSize:'20px',fontWeight:'600'}}>{type==0 ? "Select Tyre Size" : "Select Size and Details"}</div>
            </div> */}
              <div className="text-center">
                <img src="/assets/repair/tyre.svg" alt="tyre" width="50%" />
              </div>
              {/* <div style={{display:'flex',flexDirection:'row',padding:'10px',alignItems:'center',justifyContent:'center'}}>
                {type==0
                ?
                  <img src="/assets/repair/tyre.svg" />
                  :
                  <img src="/assets/repair/battery.svg" />
                  }
            </div> */}
              <Container>
                <Row className="mt-2">
                  <Col
                    className={`tab ${cart.tyreQuotation.width ? "active" : ""}`}
                    onClick={() => {
                      if (router.query.slug && router.query.slug[1] == "tyre" && !localStorage.getItem("isQuoterequest")) {
                        return
                      }
                      setFilter(0)
                    }}

                  >
                    <p>
                      Width{" "}
                      {cart.tyreQuotation.width && (
                        <> - {cart.tyreQuotation.width} <img width={20} src="/assets/correctimage-removebg-preview.webp" /></>
                      )}
                    </p>
                  </Col>
                  <Col
                    className={`tab ${cart.tyreQuotation.height ? "active" : ""}`}
                    onClick={() => {
                      if (router.query.slug && router.query.slug[1] == "tyre" && !localStorage.getItem("isQuoterequest")) {
                        return
                      }
                      setFilter(1)
                    }}

                  >
                    <p>
                      Height{" "}
                      {cart.tyreQuotation.height && (
                        <> - {cart.tyreQuotation.height} <img width={20} src="/assets/correctimage-removebg-preview.webp" /></>
                      )}
                    </p>
                  </Col>
                  <Col
                    className={`tab ${cart.tyreQuotation.rim ? "active" : ""}`}
                    onClick={() => {
                      if (router.query.slug && router.query.slug[1] == "tyre" && !localStorage.getItem("isQuoterequest")) {
                        return
                      }
                      setFilter(2)
                    }}
                  >
                    <p>
                      Rim Size{" "}
                      {cart.tyreQuotation.rim && (
                        <> - {cart.tyreQuotation.rim} <img width={20} src="/assets/correctimage-removebg-preview.webp" /></>
                      )}
                    </p>
                  </Col>
                </Row>
              </Container>
              {/* {type==0 && <div style={{zIndex:9}} className="d-flex align-items-center justify-content-center"  >
                <div className="d-flex align-items-center justify-content-evenly" style={{paddingBottom:'10px',paddingTop:'10px'}}>
                  <div style={{fontSize:'13px',width:'10vw',borderBottom:filter==0 ? '3px solid #0451be' :'3px solid #C4C4C4'}} className={`${filter==0 ? "tag-rec-selected" : "tag-rec"}`} onClick={()=>{
                    setFilter(0);
                    }}>Width</div>
                  <div style={{fontSize:'13px',width:'10vw',borderBottom:filter==1 ? '3px solid #0451be' :'3px solid #C4C4C4'}} className={`${filter==1 ? "tag-rec-selected" : "tag-rec"}`} onClick={()=>{
                    setFilter(1);
                  }}>Height</div>
                  <div style={{fontSize:'13px',width:'10vw',borderBottom:filter==2 ? '3px solid #0451be' :'3px solid #C4C4C4'}} className={`${filter==2 ? "tag-rec-selected" : "tag-rec"}`} onClick={()=>{
                    setFilter(2);
                  }}>Rim</div>
                </div>
            </div>} */}
              <Container className="text-center mt-3">
                {/* {type==0 ?<Col lg={12} style={{paddingLeft:'35px',paddingRight:'35px'}}> */}
                {filter == 0 ? (
                  <Row>
                    {widths.map((e, index) => (
                      <Col lg={2} xs={3} className="mt-2">
                        <a
                          style={{
                            padding: "5px 10px",
                            background:
                              cart.tyreQuotation.width == e.Width
                                ? "#0451be"
                                : "#F3F3F3",
                            color:
                              cart.tyreQuotation.width == e.Width
                                ? "#fff"
                                : "#000",
                          }}
                          onClick={() => setWidth(e.Width)}
                        >
                          {e.Width}
                        </a>
                      </Col>
                    ))}
                  </Row>
                ) : filter == 1 ? (
                  <Row>
                    {heights.map((e, index) => (
                      <Col lg={2} xs={3} className="mt-2">
                        <a
                          style={{
                            padding: "5px 10px",
                            background:
                              cart.tyreQuotation.height == e.Height
                                ? "#0451be"
                                : "#F3F3F3",
                            color:
                              cart.tyreQuotation.height == e.Height
                                ? "#fff"
                                : "#000",
                          }}
                          onClick={() => setHeight(e.Height)}
                        >
                          {e.Height}
                        </a>
                      </Col>
                    ))}
                  </Row>
                ) : (
                  <Row>
                    {rims.map((e, index) => (
                      <Col lg={2} xs={3} className="mt-2">
                        <a
                          style={{
                            padding: "5px 10px",
                            background:
                              cart.tyreQuotation.rim == e.Rim
                                ? "#0451be"
                                : "#F3F3F3",
                            color:
                              cart.tyreQuotation.rim == e.Rim ? "#fff" : "#000",
                          }}
                          onClick={() => setRim(e.Rim)}
                        >
                          {!localStorage.getItem("isQuoterequest") && "R"}{e.Rim}
                        </a>
                      </Col>
                    ))}
                  </Row>
                )}
              </Container>

              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  paddingBottom: "30px",
                  // paddingRight: "30px",
                  marginTop: 20,
                }}
              >
                {localStorage.getItem("isQuoterequest") ?
                  <button
                    className="open-bonnet-btn hide-in-mobile"
                    onClick={handleOBSelect}
                  >
                    Let <span className="font-weight-bold">OPEN BONNET</span>{" "}
                    Decide the Size
                  </button> : <div></div>
                  //  <div
                  //     className="tyre-back-btn"


                  //     onClick={() => { setShowMobileIstand(false);
                  //       setLayer(false);
                  //       localStorage.removeItem("isQuoterequest");
                  //       setCartJourney(workshopPurchase);}}
                  //   >
                  //     <span>Back</span>
                  //   </div>}
                }


                <div style={{ display: "flex" }}>

                  {
                    router?.pathname === `/services/[...slug]` && router?.query?.slug[1] == "tyre" && !localStorage.getItem("isQuoterequest") &&
                    <div
                      className={
                        cart?.tyreQuotation?.width
                          ? "tyre-rest-btn"
                          : "tyre-rest-btn d-none"
                      }
                      onClick={() => resetSize()}
                    >
                      <span>Reset</span>
                    </div>
                  }

                  <button
                    className={`otp-button ${cart.tyreQuotation.width === null ||
                      cart.tyreQuotation.height === null ||
                      cart.tyreQuotation.rim === null ? "btn-tyres-gray" : "btn-tyres-orng"}`}
                    style={{}}
                    onClick={proceed}

                  >
                    Proceed
                  </button>
                </div>
              </div>

            </Col>
          </Row>
          <Row className="justify-content-center">
            {localStorage.getItem("isQuoterequest") && <button
              className="open-bonnet-btn for-mobile"
              onClick={handleOBSelect}
            >
              Let <span className="font-weight-bold">OPEN BONNET</span> Decide
              the Size
            </button>}
          </Row>
          {router?.pathname === `/services/[...slug]` && router?.query?.slug[1] == "tyre" && !localStorage.getItem("isQuoterequest") &&
            <Row className="pl-3 pr-3  pb-3 texr-center">
              <p className="descriptionLine">Please ensure choosing correct tyre sizes recommended by your car manufacturer.</p>
            </Row>}
          {/* <div className='workshop-bottom-button' onClick={()=>{console.log(globalData)}}>
        <div className='workshop-select'>{"LET "}</div>
        <div className='workshop-select-ob'>{" OPEN BONNET "}</div>
        <div className='workshop-select'>{" SELECT MY GARAGE"}</div>
      </div> */}
        </Container>
      </Scrollbars>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    apiData: state.apiData,
    globalData: state.globalData,
    cart: state.cart,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    fetchTyreSelectionItems: () => {
      dispatch(fetchTyreSelectionItems());
    },
    fetchNewTyreItems: (width, height, rim) => {
      dispatch(fetchNewTyreItems(width, height, rim));
    },

    setCartTypeParameter: (data) => {
      dispatch(setCartTypeParameter(data));
    },
    setShowMobileIstand: (flag) => {
      dispatch(setShowMobileIstand(flag));
    },
    setLayer: (status) => {
      dispatch(setLayer(status));
    },
    setCartJourney: (stage) => {
      dispatch(setCartJourney(stage));
    },
    setNewCarTyreSize: (stage) => {
      dispatch(setNewCarTyreSize(stage));
    },

    getNewTyresVariants: (width, height, rim) => {
      dispatch(getNewTyresVariants(width, height, rim));
    },
    fetchNewTyreItemsHeight: (width) => {
      dispatch(fetchNewTyreItemsHeight(width));
    },
    fetchNewTyreItemsRim: (width, height) => {
      dispatch(fetchNewTyreItemsRim(width, height));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Tyre);

// fetchTyreSelectionItems
// export default ;
